import { FormOverrideTemplateType } from 'constants/forms';
import { checkIsFieldEqualToValueInData, getConditionalArray } from 'utils/data';
import { getIsFormNonOverridable } from 'utils/forms';
import { removeExcessiveSpaces } from 'utils/string';

import {
  ContentActionText,
  GLOBAL_FORM_REPLACE_WARNING,
  REPLACE_CONTENT_CONFIRMATION_QUESTION,
  ReplaceContentResetMessage,
} from './EditFormModal.constants';

export const getFormOverrideTemplateType = ({ isUseCurrentFile, isFileUploaded }) => {
  if (isUseCurrentFile) {
    return FormOverrideTemplateType.EXISTS_FORM_CONTENT;
  }

  if (isFileUploaded) {
    return FormOverrideTemplateType.NEW_PDF_CONTENT;
  }

  return FormOverrideTemplateType.NEW_EMPTY_HTML;
};

export const getIsFormNameValid = ({ name, forms }) =>
  !checkIsFieldEqualToValueInData({
    data: forms,
    value: removeExcessiveSpaces(name),
    fieldName: 'name',
  });

export const getIsFormContentReplaceable = ({
  formType,
  isCustom,
  isGlobalForm,
  isInternalCompany,
  isOverrideFlow,
  hasLocalOverride,
}) => {
  if (getIsFormNonOverridable({ formType, isCustom })) {
    return false;
  }

  if (!isGlobalForm || isInternalCompany) {
    return true;
  }

  return isOverrideFlow && !!hasLocalOverride;
};

const getReplaceContentResetMessage = ({ isPdf, isFileUploaded }) => {
  if (isFileUploaded) {
    return ReplaceContentResetMessage.NEW_PDF;
  }

  return isPdf
    ? ReplaceContentResetMessage.PDF_TO_EMPTY_HTML
    : ReplaceContentResetMessage.EMPTY_HTML;
};

export const getReplaceContentConfirmationDescription = ({
  isPdf,
  isFileUploaded,
  isAppliedToAllCompanies,
}) =>
  [
    getReplaceContentResetMessage({ isPdf, isFileUploaded }),
    ...getConditionalArray(isAppliedToAllCompanies, [GLOBAL_FORM_REPLACE_WARNING]),
    REPLACE_CONTENT_CONFIRMATION_QUESTION,
  ].join(' ');

export const getUploadButtonText = ({ isCanCreateOverride }) =>
  isCanCreateOverride ? ContentActionText.OVERRIDE : ContentActionText.REPLACE;

export const getSubmitButtonText = ({ isCanCreateOverride, isContentReplaced }) => {
  if (isCanCreateOverride || isContentReplaced) {
    return getUploadButtonText({ isCanCreateOverride });
  }

  return ContentActionText.SAVE;
};
